import { CSSProperties } from "react";
import { handleRemoveUnderscore } from "utils";
import { ThemeContainer } from "utils/Theme";

interface Props {
  statusString: string;
  styles?: CSSProperties;
}

const DotStatusField = ({ statusString, styles }: Props) => {
  const { theme } = ThemeContainer();
  const returnStatusColor = (text: string) => {
    switch (text && text?.toLowerCase()) {
      case "buy":
      case "active":
      case "match":
      case "success":
      case "finished":
      case "completed":
      case "complete":
      case "mapped":
      case "high":
      case "paid":
      case "stop_loss_hit":
      case "approved":
      case "true":
      case "auto":
      case "cash":
      case "live":
        return theme.palette.success.main;
      case "inactive":
      case "sell":
      case "not match":
      case "unmapped":
      case "low":
      case "failed":
      case "rejected":
      case "false":
        return theme.palette.error.main;
      case "moderate":
      case "manual":
      case "emandates":
        return theme.palette.info.main;
      case "partly":
      case "pending":
        return theme.palette.warning.main;
      case "bank":
        return theme.palette.grey[600];
      default:
        return `#5A5A5A`;
    }
  };

  return (
    <div
      style={{
        ...styles,
        display: styles?.display || "flex",
        alignItems: styles?.alignItems || "center",
        justifyContent: styles?.justifyContent || "center",
        borderRadius: styles?.borderRadius || 4,
        padding: styles?.padding || "2px 6px",
        fontWeight: styles?.fontWeight || 600,
        fontSize: styles?.fontSize || 12,
        color: styles?.color || returnStatusColor(statusString),
        textTransform: styles?.textTransform || "capitalize",
        width: "max-content",
        gap: 4,
      }}
    >
      <span
        style={{
          fontSize: 16,
          display: styles?.display || "flex",
          alignItems: styles?.alignItems || "center",
          justifyContent: styles?.justifyContent || "center",
        }}
      >
        •
      </span>
      {handleRemoveUnderscore(statusString?.toLowerCase())}
    </div>
  );
};

export default DotStatusField;
